<app-pagetitle title="RIESGOS" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<div class="row">
    <div class="col-xl-12">
        <div class="card">
            <div class="card-body">
                <ng-container *ngIf="planAnioSeleccionadoRedux; then headerPlan; else headerMessage"></ng-container>
                <ng-template #headerPlan>
        
                    <nav>
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <button class="nav-link active" id="nav-objetivos-tab" data-bs-toggle="tab" data-bs-target="#nav-objetivos" type="button" role="tab" aria-controls="nav-objetivos" aria-selected="false" (click)="openObjetivos()">Objetivos</button>
                            <button *ngIf="idSprNivelN5 != nivelSelect" class="nav-link " id="nav-lineasAccion-tab" data-bs-toggle="tab" data-bs-target="#nav-lineasAccion" type="button" role="tab" aria-controls="nav-lineasAccion" aria-selected="true" (click)="openLineasAccion()">Lineas de Acción</button>
                            <button *ngIf="idSprNivelN5 == nivelSelect" class="nav-link" id="nav-planAccion-tab" data-bs-toggle="tab" data-bs-target="#nav-planAccion" type="button" role="tab" aria-controls="nav-planAccion" aria-selected="false" (click)="openObjetivos()">Plan de Acción</button>
                            <button *ngIf="idSprNivelN1 != nivelSelect" class="nav-link" id="nav-proyecto-tab" data-bs-toggle="tab" data-bs-target="#nav-proyecto" type="button" role="tab" aria-controls="nav-proyecto" aria-selected="false" (click)="openProyectos()">Proyectos</button>
                        </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                        <div class="tab-pane fade show active" id="nav-objetivos" role="tabpanel" aria-labelledby="nav-objetivos-tab">

                            <app-riesgo-objetivo [init]="objetivo"></app-riesgo-objetivo>
                        </div>
                        <div class="tab-pane fade " id="nav-lineasAccion" role="tabpanel" aria-labelledby="nav-lineasAccion-tab">
                            <app-riesgo-linea-accion [init]="lineaAccion"></app-riesgo-linea-accion>
                        </div>
                        <div class="tab-pane fade" id="nav-planAccion" role="tabpanel" aria-labelledby="nav-planAccion-tab">
                            <app-riesgo-plan-accion [init]="planAccion"></app-riesgo-plan-accion>
                        </div>
                        <div class="tab-pane fade" id="nav-proyecto" role="tabpanel" aria-labelledby="nav-proyecto-tab">
                            <app-riesgo-proyecto [init]="proyecto"></app-riesgo-proyecto>
                        </div>
                    </div>
                </ng-template>
                <ng-template #headerMessage>
                    <div class="card-header  mb-2">
                        <div class="form-group row mb-2">
                            <span>Aún no ha seleccionado un plan anual</span>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div> <!-- end card-->
    </div> <!-- end col -->
</div>
<!-- end row -->